import { useContent, rich } from "@/lib/content";
import { Reveal, Eyebrow } from "./Primitives";
import { AboutCarousel } from "./AboutCarousel";

export const Nosotros = () => {
  const { HISTORY, ABOUT_PHOTOS, TEXTS: T } = useContent();

  return (
    <section id="nosotros" data-testid="nosotros-section" className="relative mx-auto max-w-[1400px] px-5 py-20 md:px-10 md:py-28 lg:py-40">
      <div className="grid gap-12 lg:grid-cols-12 lg:gap-16">
        <div className="lg:col-span-5">
          <Reveal>
            <Eyebrow className="mb-5">{T.nos_eyebrow}</Eyebrow>
            <h2 data-testid="nosotros-title" className="font-display text-3xl leading-[0.98] text-cream sm:text-4xl md:text-5xl lg:text-6xl">
              {rich(T.nos_title)}
            </h2>
          </Reveal>
          <Reveal y={30}>
            <AboutCarousel photos={ABOUT_PHOTOS} />
          </Reveal>
        </div>

        <div className="lg:col-span-6 lg:col-start-7 lg:pt-24">
          <Reveal>
            <div data-testid="nosotros-founder-card" className="mb-12 flex items-baseline gap-6 border-b border-gold/20 pb-10">
              <span className="font-display text-6xl leading-none text-gold sm:text-7xl lg:text-8xl">{T.nos_year}</span>
              <p className="font-sans text-sm leading-relaxed text-sand">
                {T.nos_year_text}
              </p>
            </div>
          </Reveal>
          <div data-testid="nosotros-history-text" className="space-y-6">
            {HISTORY.map((p, i) => (
              <Reveal key={i} delay={i * 0.05}>
                <p className={`font-sans leading-relaxed ${i === 0 ? "font-display text-xl text-cream sm:text-2xl lg:text-3xl" : "text-[15px] text-sand sm:text-base lg:text-lg"}`}>{p}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
